import React from 'react';
import { DateDropdown, Checkbox } from '../gs-component-form';
import { Field as FormikField } from 'formik';
import { Field as UnionField } from '@xo-union/tk-component-fields';
import { FormColumn, FormRow } from '@xo-union/tk-component-form-grid';
import { SeasonDropdown, YearDropdown } from './seasonYearDropdown';
import WeddingDateFormat from './weddingDateFormat';
import { DateFormProps, DatePreference } from './types';

export const TO_BE_ANNOUNCED_COPY = 'Date To Be Announced';
export const DateForm: React.FC<DateFormProps> = ({ currentView, config }) => {
  if (currentView === null) return null;
  const views = {
    [DatePreference.Season]: (
      <>
        <FormRow>
          <FormColumn md>
            <FormikField
              key="season"
              name="season"
              label="Season"
              component={SeasonDropdown}
              data-testid="season-field"
            />
          </FormColumn>
          <FormColumn md>
            <FormikField key="year" name="year" label="Year" component={YearDropdown} data-testid="year-field" />
          </FormColumn>
        </FormRow>
      </>
    ),
    [DatePreference.Exact]: (
      <>
        <FormRow>
          <FormColumn lg>
            <FormikField
              key="weddingDateField"
              name="date"
              label="Wedding Date"
              component={DateDropdown}
              data-testid="wedding-date-field"
              readOnly={false}
            />
          </FormColumn>
        </FormRow>
        {!!config?.allowFormat && (
          <>
            <FormRow>
              <FormColumn md style={{ zIndex: 2 }}>
                <WeddingDateFormat />
              </FormColumn>
            </FormRow>
            <FormRow>
              <FormColumn md>
                <FormikField
                  data-testid="hide-countdown-checkbox"
                  name="hideCountdown"
                  component={Checkbox}
                  disabledText="Display Countdown on Homepage"
                  enabledText="Display Countdown on Homepage"
                />
              </FormColumn>
            </FormRow>
          </>
        )}
      </>
    ),
    [DatePreference.Range]: (
      <>
        <FormRow>
          <FormColumn md style={{ zIndex: 3 }}>
            <FormikField
              key="weddingDateRangeStartField"
              name="rangeStart"
              label="Wedding Start Date"
              component={DateDropdown}
              readOnly={false}
              data-testid="range-start-field"
            />
          </FormColumn>
        </FormRow>
        <FormRow>
          <FormColumn md>
            <FormikField
              key="weddingDateRangeEndField"
              name="rangeEnd"
              label="Wedding End Date"
              component={DateDropdown}
              readOnly={false}
              data-testid="range-end-field"
            />
          </FormColumn>
        </FormRow>
      </>
    ),
    [DatePreference.Tba]: (
      <FormRow>
        <FormColumn md>
          <UnionField
            style={{ cursor: 'default' }}
            data-testid="hide-date-placeholder"
            name="hideDate"
            label="Date Display"
            value={TO_BE_ANNOUNCED_COPY}
            readOnly
          />
        </FormColumn>
      </FormRow>
    ),
    [DatePreference.None]: null,
  };

  return views[currentView];
};
